import isElement from '../../scripts/util/DOM/isElement';
import isViewport from '../../scripts/util/window/isViewport';
import {lg} from '../../scripts/util/window/isViewport';
import isMobile from 'ismobilejs';
import Parallax from 'parallax-scroll';

const selectors = {
	el: '.js-howto-page',
	stage: {
		img: '.js-stage-img'
	}
};

const stageParallax = () => {
	const parallax = new Parallax(selectors.stage.img, {
		speed: 0.1
	});
	parallax.animate();
};

const render = () => {
	if (isElement(selectors.el) && !isViewport(lg) && !isMobile.any) {
		stageParallax();
	}
};

export default render;



// WEBPACK FOOTER //
// ./app/blocks/howto/index.js